import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Collapse,
  Input,
  Card,
  Form,
  DatePicker,
  Cascader,
  Select,
  Checkbox,
  Button,
  Spin,
  Empty,
  Divider,
  Space,
} from 'antd';
import {
  PlusOutlined,
  MinusOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import * as getClientbyIdService from '../../../services/getClientbyID';
import TripleToggle from "../../../components/trippleToggle/trippleToggle";
import { useDispatch } from 'react-redux';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const timeampm = [
  {
    value: 'AM',
    label: 'AM',
  },
  {
    value: 'PM',
    label: 'PM',
  },
];

const FirstStep = (props) => {
  console.warn('FirstStep', props);
  var dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isOpenClient, setIsOpenClient] = useState(false);
  const [isOpenBtn, setIsOpenBtn] = useState(true);
  const [homeOwnerData, setHomeOwnerData] = useState({});
  const [originalhomeOwnerData, setOriginalHomeOwnerData] = useState({});
  const [flooringcontractorData, setflooringcontractorData] = useState({});
  const [originalflooringcontractorData, setOriginalflooringcontractorData] = useState({});
  const [generalcontractor, setGeneralContractor] = useState({});
  const [originalgeneralcontractor, setOriginalGeneralContractor] = useState({});
  const [manufacturerData, setManufacturerData] = useState({});
  const [originalmanufacturerData, setOriginalManufacturerData] = useState({});
  const [reatailerData, setReatailerData] = useState({});
  const [originalreatailerData, setOriginalReatailerData] = useState({});
  const [initialValues, setInitialValues] = useState({});
      const [currentValues, setCurrentValues] = useState({});
      
          useEffect(() => {
            if (props.values) {
              setInitialValues(props.values);
            }
          }, [props.values]);
      
          useEffect(() => {
            if (props.values) {
              setCurrentValues(props.values);
            }
          },[]);
      
        const getFieldBgColor = (fieldName) => {
           if (props.editMode) {
            return '#ffffff'; // Always white in edit mode
          }
          const initial = initialValues[fieldName];
          const current = currentValues[fieldName];
      
          if (initial && initial===current) {
            return '#f0f0f0'; // grey if prefilled and unchanged
          }
          return '#ffffff'; // white otherwise
        };

  const getHomeOwnerData = (e) => {
    let value = props.values;
    if(e.target.checked){
      // BACKUP ORIGINAL VALUES
      setOriginalHomeOwnerData({
        homeowner_Name: value.homeowner_Name || "",
        homeowner_street: value.homeowner_street || "",
        homeowne_country: value.homeowne_country || "",
        homeowner_city: value.homeowner_city || "",
        homeowner_state: value.homeowner_state || "",
        homeowner_zip: value.homeowner_zip || "",
        homeowner_contact_number: value.homeowner_contact_number || "",
        homeowner_email: value.homeowner_email || "",
      });

      let newval = {
        commisioning_name: value.commisioning_name,
        commisioning_party_street: value.commisioning_party_street,
        commisioning_party_country: value.commisioning_party_country,
        commisioning_party_city: value.commisioning_party_city,
        commisioning_party_state: value.commisioning_party_state,
        commisioning_party_zip: value.commisioning_party_zip,
        commisioning_party_contact_number:
          value.commisioning_party_contact_number,

        commisioning_party_email: value.commisioning_party_email,
      };
      setHomeOwnerData(newval);
      props.values.homeowner_Name = newval.commisioning_name;
      props.values.homeowner_street = newval.commisioning_party_street;
      props.values.homeowne_country = newval.commisioning_party_country;
      props.values.homeowner_city = newval.commisioning_party_city;
      props.values.homeowner_state = newval.commisioning_party_state;
      props.values.homeowner_zip = newval.commisioning_party_zip;
      props.values.homeowner_contact_number =
        newval.commisioning_party_contact_number;
      props.values.homeowner_email = newval.commisioning_party_email;
      props.values.commishomeowner = true;

      form.setFieldsValue({
        homeowner_Name: newval.commisioning_name,
        homeowner_street: newval.commisioning_party_street,
        homeowne_country: newval.commisioning_party_country,
        homeowner_city: newval.commisioning_party_city,
        homeowner_state: newval.commisioning_party_state,
        homeowner_zip: newval.commisioning_party_zip,
        homeowner_contact_number:
          newval.commisioning_party_contact_number,
        homeowner_email: newval.commisioning_party_email,
      });

    }else{
      setHomeOwnerData({});
      props.values.homeowner_Name =  originalhomeOwnerData.homeowner_Name || "";
      props.values.homeowner_street =  originalhomeOwnerData.homeowner_street || "";
      props.values.homeowne_country =  originalhomeOwnerData.homeowne_country || "";
      props.values.homeowner_city =  originalhomeOwnerData.homeowner_city || "";
      props.values.homeowner_state =  originalhomeOwnerData.homeowner_state || "";
      props.values.homeowner_zip =  originalhomeOwnerData.homeowner_zip || "";
      props.values.homeowner_contact_number =  originalhomeOwnerData.homeowner_contact_number || "";
      props.values.homeowner_email =  originalhomeOwnerData.homeowner_email || "";
      props.values.commishomeowner = false;

      form.setFieldsValue({
        homeowner_Name:  originalhomeOwnerData.homeowner_Name || "",
        homeowner_street:  originalhomeOwnerData.homeowner_street || "",
        homeowne_country:  originalhomeOwnerData.homeowne_country || "",
        homeowner_city:  originalhomeOwnerData.homeowner_city || "",
        homeowner_state:  originalhomeOwnerData.homeowner_state || "",
        homeowner_zip:  originalhomeOwnerData.homeowner_zip || "",
        homeowner_contact_number:  originalhomeOwnerData.homeowner_contact_number || "",
        homeowner_email:  originalhomeOwnerData.homeowner_email || "",
      });
    } 
  };

  const getFlooringContractorData = (e) => {
    let value = props.values;
    if(e.target.checked){
      // BACKUP ORIGINAL VALUES
      setOriginalflooringcontractorData({
        flooring_contractor_Name: value.flooring_contractor_Name || "",
        flooring_contractor_street: value.flooring_contractor_street || "",
        flooring_contractor_country: value.flooring_contractor_country || "",
        flooring_contractor_city: value.flooring_contractor_city || "",
        flooring_contractor_state: value.flooring_contractor_state || "",
        flooring_contractor_zip: value.flooring_contractor_zip || "",
        flooring_contractor_contact_number: value.flooring_contractor_contact_number || "",
        flooring_contractor_email: value.flooring_contractor_email || "",
      });

      let newval = {
        commisioning_name: value.commisioning_name,
        commisioning_party_street: value.commisioning_party_street,
        commisioning_party_country: value.commisioning_party_country,
        commisioning_party_city: value.commisioning_party_city,
        commisioning_party_state: value.commisioning_party_state,
        commisioning_party_zip: value.commisioning_party_zip,
        commisioning_party_contact_number:
          value.commisioning_party_contact_number,
        commisioning_party_email: value.commisioning_party_email,
      };
      setflooringcontractorData(newval);
      console.info('flooringContractorData', newval);
      props.values.flooring_contractor_Name = newval.commisioning_name;
      props.values.flooring_contractor_street = newval.commisioning_party_street;
      props.values.flooring_contractor_country =
        newval.commisioning_party_country;
      props.values.flooring_contractor_city = newval.commisioning_party_city;
      props.values.flooring_contractor_state = newval.commisioning_party_state;
      props.values.flooring_contractor_zip = newval.commisioning_party_zip;
      props.values.flooring_contractor_contact_number =
        newval.commisioning_party_contact_number;
      props.values.flooring_contractor_email = newval.commisioning_party_email;

      props.values.flooringContractorData = true;

      form.setFieldsValue({
        flooring_contractor_Name: newval.commisioning_name,
        flooring_contractor_street: newval.commisioning_party_street,
        flooring_contractor_country:
          newval.commisioning_party_country,
        flooring_contractor_city: newval.commisioning_party_city,
        flooring_contractor_state: newval.commisioning_party_state,
        flooring_contractor_zip: newval.commisioning_party_zip,
        flooring_contractor_contact_number:
          newval.commisioning_party_contact_number,
        flooring_contractor_email: newval.commisioning_party_email,
      });

    }else{
      setflooringcontractorData({});
      props.values.flooring_contractor_Name = originalflooringcontractorData.flooring_contractor_Name || "";
      props.values.flooring_contractor_street = originalflooringcontractorData.flooring_contractor_street || "";
      props.values.flooring_contractor_country = originalflooringcontractorData.flooring_contractor_country || "";
      props.values.flooring_contractor_city = originalflooringcontractorData.flooring_contractor_city || "";
      props.values.flooring_contractor_state = originalflooringcontractorData.flooring_contractor_state || "";
      props.values.flooring_contractor_zip = originalflooringcontractorData.flooring_contractor_zip || "";
      props.values.flooring_contractor_contact_number = originalflooringcontractorData.flooring_contractor_contact_number || "";
      props.values.flooring_contractor_email = originalflooringcontractorData.flooring_contractor_email || "";
      props.values.flooringContractorData = false;

      form.setFieldsValue({
        flooring_contractor_Name: originalflooringcontractorData.flooring_contractor_Name || "",
        flooring_contractor_street: originalflooringcontractorData.flooring_contractor_street || "",
        flooring_contractor_country: originalflooringcontractorData.flooring_contractor_country || "",
        flooring_contractor_city: originalflooringcontractorData.flooring_contractor_city || "",
        flooring_contractor_state: originalflooringcontractorData.flooring_contractor_state || "",
        flooring_contractor_zip: originalflooringcontractorData.flooring_contractor_zip || "",
        flooring_contractor_contact_number: originalflooringcontractorData.flooring_contractor_contact_number || "",
        flooring_contractor_email: originalflooringcontractorData.flooring_contractor_email || "",
      });
    } 

  };

  const getGeneralContractorData = (e) => {
    let value = props.values;
    if(e.target.checked){
      // BACKUP ORIGINAL VALUES
      setOriginalGeneralContractor({
        general_contractor_name: value.general_contractor_name || "",
        general_contractor_street: value.general_contractor_street || "",
        general_contractor_country: value.general_contractor_country || "",
        general_contractor_city: value.general_contractor_city || "",
        general_contractor_state: value.general_contractor_state || "",
        general_contractor_zip: value.general_contractor_zip || "",
        general_contractor_contact_number: value.general_contractor_contact_number || "",
        general_contractor_email: value.general_contractor_email || "",
      });

      let newval = {
        commisioning_name: value.commisioning_name,
        commisioning_party_street: value.commisioning_party_street,
        commisioning_party_country: value.commisioning_party_country,
        commisioning_party_city: value.commisioning_party_city,
        commisioning_party_state: value.commisioning_party_state,
        commisioning_party_zip: value.commisioning_party_zip,
        commisioning_party_contact_number:
          value.commisioning_party_contact_number,
        commisioning_party_email: value.commisioning_party_email,
      };
      setGeneralContractor(newval);
      console.info('generalContractordata', newval);
      props.values.general_contractor_name = newval.commisioning_name;
      props.values.general_contractor_street = newval.commisioning_party_street;
      props.values.general_contractor_country = newval.commisioning_party_country;
      props.values.general_contractor_city = newval.commisioning_party_city;
      props.values.general_contractor_state = newval.commisioning_party_state;
      props.values.general_contractor_zip = newval.commisioning_party_zip;
      props.values.general_contractor_contact_number =
        newval.commisioning_party_contact_number;
      props.values.general_contractor_email = newval.commisioning_party_email;
      props.values.generalContractor = true;

      form.setFieldsValue({
        general_contractor_name: newval.commisioning_name,
        general_contractor_street: newval.commisioning_party_street,
        general_contractor_country: newval.commisioning_party_country,
        general_contractor_city: newval.commisioning_party_city,
        general_contractor_state: newval.commisioning_party_state,
        general_contractor_zip: newval.commisioning_party_zip,
        general_contractor_contact_number:
          newval.commisioning_party_contact_number,
        general_contractor_email: newval.commisioning_party_email,
      });

    }else{
      setGeneralContractor({});
      props.values.general_contractor_name = originalgeneralcontractor.general_contractor_name || "";
      props.values.general_contractor_street = originalgeneralcontractor.general_contractor_street || "";
      props.values.general_contractor_country = originalgeneralcontractor.general_contractor_country || "";
      props.values.general_contractor_city = originalgeneralcontractor.general_contractor_city || "";
      props.values.general_contractor_state = originalgeneralcontractor.general_contractor_state || "";
      props.values.general_contractor_zip = originalgeneralcontractor.general_contractor_zip || "";
      props.values.general_contractor_contact_number = originalgeneralcontractor.general_contractor_contact_number || "";
      props.values.general_contractor_email = originalgeneralcontractor.general_contractor_email || "";
      props.values.generalContractor = false;

      form.setFieldsValue({
        general_contractor_name: originalgeneralcontractor.general_contractor_name || "",
        general_contractor_street: originalgeneralcontractor.general_contractor_street || "",
        general_contractor_country: originalgeneralcontractor.general_contractor_country || "",
        general_contractor_city: originalgeneralcontractor.general_contractor_city || "",
        general_contractor_state: originalgeneralcontractor.general_contractor_state || "",
        general_contractor_zip: originalgeneralcontractor.general_contractor_zip || "",
        general_contractor_contact_number: originalgeneralcontractor.general_contractor_contact_number || "",
        general_contractor_email: originalgeneralcontractor.general_contractor_email || "",
      });
    } 

  };

  const getManufacturerData = (e) => {
    let value = props.values;
    if(e.target.checked){
      // BACKUP ORIGINAL VALUES
      setOriginalManufacturerData({
        manufacturer_name: value.manufacturer_name || "",
        manufacturer_street: value.manufacturer_street || "",
        manufacturer_country: value.manufacturer_country || "",
        manufacturer_city: value.manufacturer_city || "",
        manufacturer_state: value.manufacturer_state || "",
        manufacturer_zip: value.manufacturer_zip || "",
        manufacturer_email: value.manufacturer_email || "",
        manufacturer_contact_number: value.manufacturer_contact_number || "",
      });

      let newval = {
        commisioning_name: value.commisioning_name,
        commisioning_party_street: value.commisioning_party_street,
        commisioning_party_country: value.commisioning_party_country,
        commisioning_party_city: value.commisioning_party_city,
        commisioning_party_state: value.commisioning_party_state,
        commisioning_party_zip: value.commisioning_party_zip,
        commisioning_party_contact_number:
          value.commisioning_party_contact_number,
        commisioning_party_email: value.commisioning_party_email,
      };
      setManufacturerData(newval);
      console.info('ManufacturerData', newval);
      props.values.manufacturer_name = newval.commisioning_name;
      props.values.manufacturer_street = newval.commisioning_party_street;
      props.values.manufacturer_country = newval.commisioning_party_country;
      props.values.manufacturer_city = newval.commisioning_party_city;
      props.values.manufacturer_state = newval.commisioning_party_state;
      props.values.manufacturer_zip = newval.commisioning_party_zip;
      props.values.manufacturer_email = newval.commisioning_party_email;
      props.values.manufacturer_contact_number =
        newval.commisioning_party_contact_number;
      props.values.manufacturerData = true;

      form.setFieldsValue({
        manufacturer_name: newval.commisioning_name,
        manufacturer_street: newval.commisioning_party_street,
        manufacturer_country: newval.commisioning_party_country,
        manufacturer_city: newval.commisioning_party_city,
        manufacturer_state: newval.commisioning_party_state,
        manufacturer_zip: newval.commisioning_party_zip,
        manufacturer_email: newval.commisioning_party_email,
        manufacturer_contact_number:
          newval.commisioning_party_contact_number,
      });
    }else{
      setManufacturerData({});
      props.values.manufacturer_name = originalmanufacturerData.manufacturer_name || "";
      props.values.manufacturer_street = originalmanufacturerData.manufacturer_street || "";
      props.values.manufacturer_country = originalmanufacturerData.manufacturer_country || "";
      props.values.manufacturer_city = originalmanufacturerData.manufacturer_city || "";
      props.values.manufacturer_state = originalmanufacturerData.manufacturer_state || "";
      props.values.manufacturer_zip = originalmanufacturerData.manufacturer_zip || "";
      props.values.manufacturer_email = originalmanufacturerData.manufacturer_email || "";
      props.values.manufacturer_contact_number = originalmanufacturerData.manufacturer_contact_number || "";
      props.values.manufacturerData = false;

      form.setFieldsValue({
        manufacturer_name: originalmanufacturerData.manufacturer_name || "",
        manufacturer_street: originalmanufacturerData.manufacturer_street || "",
        manufacturer_country: originalmanufacturerData.manufacturer_country || "",
        manufacturer_city: originalmanufacturerData.manufacturer_city || "",
        manufacturer_state: originalmanufacturerData.manufacturer_state || "",
        manufacturer_zip: originalmanufacturerData.manufacturer_zip || "",
        manufacturer_email: originalmanufacturerData.manufacturer_email || "",
        manufacturer_contact_number: originalmanufacturerData.manufacturer_contact_number || "",
      });
    } 

  };

  const getReatailerData = (e) => {
    let value = props.values;
    if(e.target.checked){
      // BACKUP ORIGINAL VALUES
      setOriginalReatailerData({
        retailer_name: value.retailer_name || "",
        retailer_street: value.retailer_street || "",
        retailer_country: value.retailer_country || "",
        retailer_city: value.retailer_city || "",
        retailer_state: value.retailer_state || "",
        retailer_zip: value.retailer_zip || "",
        retailer_contact_number: value.retailer_contact_number || "",
        retailer_email: value.retailer_email || "",
      });

      let newval = {
        commisioning_name: value.commisioning_name,
        commisioning_party_street: value.commisioning_party_street,
        commisioning_party_country: value.commisioning_party_country,
        commisioning_party_city: value.commisioning_party_city,
        commisioning_party_state: value.commisioning_party_state,
        commisioning_party_zip: value.commisioning_party_zip,
        commisioning_party_contact_number:
          value.commisioning_party_contact_number,
        commisioning_party_email: value.commisioning_party_email,
      };
      setReatailerData(newval);
      console.info('ReatailerData', newval);
      props.values.retailer_name = newval.commisioning_name;
      props.values.retailer_street = newval.commisioning_party_street;
      props.values.retailer_country = newval.commisioning_party_country;
      props.values.retailer_city = newval.commisioning_party_city;
      props.values.retailer_state = newval.commisioning_party_state;
      props.values.retailer_zip = newval.commisioning_party_zip;
      props.values.retailer_contact_number =
        newval.commisioning_party_contact_number;
      props.values.retailer_email = newval.commisioning_party_email;
      props.values.reatailerData = true;

      form.setFieldsValue({
        retailer_name: newval.commisioning_name,
        retailer_street: newval.commisioning_party_street,
        retailer_country: newval.commisioning_party_country,
        retailer_city: newval.commisioning_party_city,
        retailer_state: newval.commisioning_party_state,
        retailer_zip: newval.commisioning_party_zip,
        retailer_contact_number:
          newval.commisioning_party_contact_number,
        retailer_email: newval.commisioning_party_email,
      });

    }else{
      setReatailerData({});
      props.values.retailer_name =   originalreatailerData.retailer_name || "";
      props.values.retailer_street =  originalreatailerData.retailer_street || "";
      props.values.retailer_country =  originalreatailerData.retailer_country || "";
      props.values.retailer_city =  originalreatailerData.retailer_city || "";
      props.values.retailer_state =  originalreatailerData.retailer_state || "";
      props.values.retailer_zip =  originalreatailerData.retailer_zip || "";
      props.values.retailer_contact_number =  originalreatailerData.retailer_contact_number || "";
      props.values.retailer_email =  originalreatailerData.retailer_email || "";
      props.values.reatailerData = false;

      form.setFieldsValue({
        retailer_name:   originalreatailerData.retailer_name || "",
        retailer_street:  originalreatailerData.retailer_street || "",
        retailer_country:  originalreatailerData.retailer_country || "",
        retailer_city:  originalreatailerData.retailer_city || "",
        retailer_state:  originalreatailerData.retailer_state || "",
        retailer_zip:  originalreatailerData.retailer_zip || "",
        retailer_contact_number:  originalreatailerData.retailer_contact_number || "",
        retailer_email:  originalreatailerData.retailer_email || "",
      });
    } 

  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.values.client_id && props.clientDropdown) {
      const clientName = props.clientDropdown.find(c => String(c.id) === String(props.values.client_id))?.name;
      if (clientName) {
        form.setFieldsValue({
          client_select_drop: {
            value: props.values.client_id,
            label: clientName,
          },
        });
      } else {
        const nonStandardClientName = props.values.commisioning_name || props.values.client_id;
        form.setFieldsValue({
          client_select_drop: {
            value: props.values.client_id,
            label: nonStandardClientName,
          },
        });
      }
    }
  }, [props.values.client_id, props.clientDropdown, form]);

  const DateFormat = 'MM-DD-YYYY';

  const addClient = () => {
    setIsOpenClient(false);
    setIsOpenBtn(true);
    form.setFieldsValue({
      commisioning_name: '',
      commisioning_party_address: '',
      commisioning_party_street: '',
      commisioning_party_country: '',
      commisioning_party_city: '',
      commisioning_party_state: '',
      commisioning_party_zip: '',
      commisioning_party_contact_number: '',
      commisioning_party_email: '',
    });
  };
  const getClientbyId = (option) => {
    const key = option.value;
    setIsOpenBtn(false);
    props.values.client_select_drop = key;
    dispatch(getClientbyIdService.getClientbyId(key))
      .then((res) => {
        form.setFieldsValue({
          commisioning_name: res.name,
          comm_party_drop: res.comm_party_drop,
          commisioning_party_email: res.email,
          commisioning_party_street: res.street,
          commisioning_party_city: res.city,
          commisioning_party_state: res.states,
          commisioning_party_zip: res.zip_code,
          commisioning_party_country: res.country,
          commisioning_party_contact_number: res.phone_personal,
        });
        props.handleFill({
          commisioning_name: res.name,
          commisioning_party_address: res.address,
          comm_party_drop: res.comm_party_drop,
          commisioning_party_email: res.email,
          commisioning_party_street: res.street,
          commisioning_party_country: res.country,
          commisioning_party_state: res.states,
          commisioning_party_city: res.city,
          commisioning_party_zip: res.zip_code,
          commisioning_party_contact_number: res.phone_personal,
        });
      })
      .catch((err) => {
          // Extract and display a meaningful error message
      let errorMessage;

      if (err.response) {
        // The request was made and the server responded with a status code outside of the 2xx range
        errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
      } else if (err.request) {
        // The request was made but no response was received
        errorMessage = "No response received from the server. Please check your network connection.";
      } else {
        // Something else happened while setting up the request
        errorMessage = `An unexpected error occurred: ${err.message}`;
      }

      // Display the error message in an alert or use a UI notification component
      alert(errorMessage);
      });
  };
  const hideClient = () => {
    setIsOpenBtn(false);
  };
  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      {props.loading ? (
        <div className="spinDiv fullHeight">
          <Spin size="large" />
        </div>
      ) : (
        <Form
          name="report"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          form={form}
        >
          <Card className="reportCard">
            <div className="reportCardBody">
              <div className="formSection">
                <div className="inspectionSection">
                  <div className="inspecHead">
                    <h4 className="formGroupTitle">General Information</h4>
                  </div>
                  <div className="inspecContent">
                    <Row gutter={16}>
                      <Col xs={24} md={6} xl={6}>
                        <div className="formGroup">
                          <Form.Item label="Claim Number" name="claim_number">
                            <Input
                              placeholder="Claim Number"
                              className="formControl"
                              onChange={props.handleChange('claim_number')}
                              style={{ backgroundColor: getFieldBgColor('claim_number') }}
                              defaultValue={props.values.claim_number}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xs={24} md={6} xl={6}>
                        <div className="formGroup">
                          <Form.Item
                            label="Inspector Name"
                            name="inspection_name"
                          >
                            <Input
                              placeholder="Inspector Name"
                              className="formControl"
                              onChange={props.handleChange('inspection_name')}
                              style={{ backgroundColor: getFieldBgColor('inspection_name') }}
                              defaultValue={props.values.inspection_name}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xs={24} md={6} xl={6}>
                        <div className="formGroup">
                          <Form.Item
                            label="Inspection Date"
                            name="h_bi_ins_date"
                          >
                            <Input.Group compact className="mt-0">
                              <Input
                                placeholder="Inspection Date"
                                className="formControl"
                                onChange={(e) =>
                                  props.handleDateformate(
                                    e,
                                    'h_bi_ins_date',
                                    'text'
                                  )
                                }
                                style={{ backgroundColor: getFieldBgColor('h_bi_ins_date') }}
                                value={props.values.h_bi_ins_date}
                                onFocus={() => props.setCalOpen(!props.calOpen)}
                                onKeyUp={() => props.setCalOpen(false)}
                                onBlur={() => props.setCalOpen(false)}
                              />

                              <Button
                                className="btnAddOn"
                                icon={<CalendarOutlined />}
                                onClick={() => props.setCalOpen(!props.calOpen)}
                              />
                            </Input.Group>
                            <DatePicker
                              className="formControl dateHide"
                              format={DateFormat}
                              open={props.calOpen}
                              style={{ visibility: 'hidden', width: 0,backgroundColor: getFieldBgColor('h_bi_ins_date') }}
                              onChange={(e) =>
                                props.handleDateformate(
                                  e,
                                  'h_bi_ins_date',
                                  'date'
                                )
                              }
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xs={24} md={6} xl={6}>
                        <div className="formGroup">
                          <Form.Item
                            label="Inspector CP #"
                            name="inspection_cp"
                          >
                            <Input
                              placeholder="Inspector CP"
                              className="formControl"
                              onChange={props.handleChange('inspection_cp')}
                              style={{ backgroundColor: getFieldBgColor('inspection_cp') }}
                              defaultValue={props.values.inspection_cp}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="CollapseSection">
                    <Collapse
                      defaultActiveKey={
                        props.values.stepOneTogg
                          ? props.values.stepOneTogg
                          : ['1', '2', '3', '4', '5', '6', '7']
                      }
                      onChange={props.handleChange('stepOneTogg')}
                      className="reportCollapse"
                      expandIcon={({ isActive }) =>
                        isActive ? (
                          <MinusOutlined className="custom-icon" />
                        ) : (
                          <PlusOutlined className="custom-icon" />
                        )
                      }
                      ghost
                    >
                      <Panel header="Commissioning Party Information" key="1">
                        <Row gutter={16}>
                          {props.values?.client_type ===
                          'Flooring Manufacturer' ? (
                            ''
                          ) : (
                            <Col xs={24} md={6} xl={6}>
                              <div className="formGroup">
                                <Form.Item
                                  label="Select Client"
                                  name="client_select_drop"
                                >
                                  <Select
                                    labelInValue
                                    showSearch
                                    placeholder="Select Client"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                  typeof option?.children === 'string'
                                    ? option.children.toLowerCase().includes(input.toLowerCase())
                                    : false
                                }
                                    filterSort={(optionA, optionB) =>
                                  (typeof optionA?.children === 'string' ? optionA.children : '')
                                    .toLowerCase()
                                    .localeCompare(
                                      (typeof optionB?.children === 'string' ? optionB.children : '').toLowerCase()
                                    )
                                }
                                    onChange={getClientbyId}
                                    open={isOpenClient}
                                    onDropdownVisibleChange={(visible) =>
                                      setIsOpenClient(visible)
                                    }
                                    dropdownRender={(menu) => (
                                      <>
                                        {menu}
                                        <Divider
                                          style={{
                                            margin: '0',
                                          }}
                                        />
                                        <Space className="renderBtn">
                                          <Button
                                            type="text"
                                            icon={<PlusOutlined />}
                                            onClick={() => addClient()}
                                            block
                                          >
                                            Add New Client
                                          </Button>
                                        </Space>
                                      </>
                                    )}
                                  >
                                    {props.clientDropdown ? (
                                      props.clientDropdown.map((option, id) => {
                                        return (
                                          <Option value={option.id} key={id}>
                                            {option.name}
                                          </Option>
                                        );
                                      })
                                    ) : (
                                      <Option value="No data">
                                        <Empty />
                                      </Option>
                                    )}
                                  </Select>
                                </Form.Item>
                              </div>
                            </Col>
                          )}

                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Commissioning Party"
                                name="comm_party_drop"
                              >
                                <Select
                                  defaultValue={
                                    props.values.comm_party_drop
                                      ? props.values.comm_party_drop
                                      : 'Commissioning Party'
                                  }
                                  onChange={props.handleChange(
                                    'comm_party_drop'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('comm_party_drop') }}
                                >
                                  <Option value="Manufacturer">
                                    Manufacturer
                                  </Option>
                                  <Option value="Dealer">Dealer</Option>
                                  <Option value="Distributor">
                                    Distributor
                                  </Option>
                                  <Option value="Homeowner">Homeowner</Option>
                                  <Option value="Attorney">Attorney</Option>
                                  <Option value="Builder">Builder</Option>
                                  <Option value="Insurance Company">
                                    Insurance Company
                                  </Option>
                                  <Option value="Installer">Installer</Option>
                                  <Option value="Other">Other</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          {props.isOpen.comm_party_drop_Field === true ||
                          props.values.comm_party_drop === 'Other' ? (
                            <Col xs={24} md={6} xl={6}>
                              <div className="formGroup">
                                <Form.Item
                                  label="Other"
                                  name="comm_party_drop_other"
                                >
                                  <Input
                                    placeholder="Other"
                                    className="formControl"
                                    onChange={props.handleChange(
                                      'comm_party_drop_other'
                                    )}
                                    style={{ backgroundColor: getFieldBgColor('comm_party_drop_other') }}
                                    defaultValue={
                                      props.values.comm_party_drop_other
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                          ) : null}
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item label="Name" name="commisioning_name">
                                <Input
                                  placeholder="Name"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_name'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_name') }}
                                  defaultValue={props.values.commisioning_name}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Street Name/Number"
                                name="commisioning_party_street"
                                //valuePropName={commissioningData?.Home_street}
                              >
                                <Input
                                  placeholder="Street Name/Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_street'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_street') }}
                                  // value={commissioningData?.Home_street}
                                  defaultValue={
                                    props.values.commisioning_party_street
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="City"
                                name="commisioning_party_city"
                              >
                                <Input
                                  placeholder="City"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_city'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_city') }}
                                  defaultValue={
                                    props.values.commisioning_party_city
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="State"
                                name="commisioning_party_state"
                              >
                                <Input
                                  placeholder="State"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_state'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_state') }}
                                  defaultValue={
                                    props.values.commisioning_party_state
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Country"
                                name="commisioning_party_country"
                                //valuePropName={commissioningData?.Home_country}
                              >
                                <Input
                                  placeholder="Country"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_country'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_country') }}
                                  defaultValue={
                                    props.values.commisioning_party_country
                                  }
                                  //value={commissioningData?.Home_country}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Zip"
                                name="commisioning_party_zip"
                              >
                                <Input
                                  placeholder="Zip"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_zip'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_zip') }}
                                  defaultValue={
                                    props.values.commisioning_party_zip
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Contact Number"
                                name="commisioning_party_contact_number"
                              >
                                <Input
                                  placeholder="Contact Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_contact_number'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_contact_number') }}
                                  defaultValue={
                                    props.values
                                      .commisioning_party_contact_number
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Email"
                                name="commisioning_party_email"
                              >
                                <Input
                                  placeholder="Email"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'commisioning_party_email'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('commisioning_party_email') }}
                                  defaultValue={
                                    props.values.commisioning_party_email
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          {isOpenBtn ? (
                            <Col
                              xs={24}
                              md={6}
                              xl={6}
                              className="d-flex justify-content-start align-items-center"
                            >
                              <div className="formGroup">
                                <Button
                                  className="btnSecondary me-2"
                                  onClick={props.addClient}
                                >
                                  Add Client
                                </Button>
                                <Button
                                  className="btnSecondary me-2"
                                  onClick={() => hideClient()}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          ) : (
                            ''
                          )}
                        </Row>
                      </Panel>
                      <Panel header="Homeowner/Building Information" key="2">
                        <Row gutter={16}>
                          <div className="m-2">
                            <Form.Item name="commishomeowner">
                              <Checkbox
                                onChange={getHomeOwnerData}
                                defaultChecked={props.values.commishomeowner}
                              >
                                Check this box if Homeowner/Building is
                                Commissioning Party
                              </Checkbox>
                            </Form.Item>
                          </div>
                        </Row>
                        <Row gutter={16}>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Name"
                                name="homeowner_Name"
                                valuePropName={homeOwnerData?.commisioning_name}
                              >
                                <Input
                                  placeholder="Name"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'homeowner_Name'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_Name') }}
                                  value={homeOwnerData?.commisioning_name}
                                  defaultValue={props.values.homeowner_Name}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Street Name/Number"
                                name="homeowner_street"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_street
                                }
                              >
                                <Input
                                  placeholder="Street Name/Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'homeowner_street'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_street') }}
                                  value={
                                    homeOwnerData?.commisioning_party_street
                                  }
                                  defaultValue={props.values.homeowner_street}
                                />
                              </Form.Item>
                            </div>
                          </Col>

                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="City"
                                name="homeowner_city"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_city
                                }
                              >
                                <Input
                                  placeholder="City"
                                  value={homeOwnerData?.commisioning_party_city}
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'homeowner_city'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_city') }}
                                  defaultValue={props.values.homeowner_city}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="State"
                                name="homeowner_state"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_state
                                }
                              >
                                <Input
                                  placeholder="State"
                                  className="formControl"
                                  value={
                                    homeOwnerData?.commisioning_party_state
                                  }
                                  onChange={props.handleChange(
                                    'homeowner_state'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_state') }}
                                  defaultValue={props.values.homeowner_state}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Country"
                                name="homeowne_country"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_country
                                }
                              >
                                <Input
                                  placeholder="Country"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'homeowne_country'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowne_country') }}
                                  defaultValue={props.values.homeowne_country}
                                  value={
                                    homeOwnerData?.commisioning_party_country
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Zip"
                                name="homeowner_zip"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_zip
                                }
                              >
                                <Input
                                  placeholder="Zip"
                                  className="formControl"
                                  value={homeOwnerData?.commisioning_party_zip}
                                  onChange={props.handleChange('homeowner_zip')}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_zip') }}
                                  defaultValue={props.values.homeowner_zip}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Contact Number"
                                name="homeowner_contact_number"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_contact_number
                                }
                              >
                                <Input
                                  placeholder="Contact Number"
                                  className="formControl"
                                  value={
                                    homeOwnerData?.commisioning_party_contact_number
                                  }
                                  onChange={props.handleChange(
                                    'homeowner_contact_number'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_contact_number') }}
                                  defaultValue={
                                    props.values.homeowner_contact_number
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Email"
                                name="homeowner_email"
                                valuePropName={
                                  homeOwnerData?.commisioning_party_email
                                }
                              >
                                <Input
                                  placeholder="Email"
                                  className="formControl"
                                  value={
                                    homeOwnerData?.commisioning_party_email
                                  }
                                  onChange={props.handleChange(
                                    'homeowner_email'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('homeowner_email') }}
                                  defaultValue={props.values.homeowner_email}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                      <Panel header="Flooring Contractor Information" key="3">
                        <Row gutter={16}>
                          <div className="m-2">
                            <Form.Item name="flooringContractorData">
                              <Checkbox
                                onChange={getFlooringContractorData}
                                defaultChecked={
                                  props.values.flooringContractorData
                                }
                              >
                                Check this box if Flooring Contractor is
                                Commissioning Party
                              </Checkbox>
                            </Form.Item>
                          </div>
                        </Row>
                        <Row gutter={16}>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Name"
                                name="flooring_contractor_Name"
                                valuePropName={
                                  flooringcontractorData?.commisioning_name
                                }
                              >
                                <Input
                                  placeholder="Name"
                                  className="formControl"
                                  value={
                                    flooringcontractorData?.commisioning_name
                                  }
                                  onChange={props.handleChange(
                                    'flooring_contractor_Name'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_Name') }}
                                  defaultValue={
                                    props.values.flooring_contractor_Name
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Street Name/Number "
                                name="flooring_contractor_street"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_street
                                }
                              >
                                <Input
                                  placeholder="Street Name/Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'flooring_contractor_street'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_street') }}
                                  value={
                                    flooringcontractorData?.commisioning_party_street
                                  }
                                  defaultValue={
                                    props.values.flooring_contractor_street
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="City"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_city
                                }
                                name="flooring_contractor_city"
                              >
                                <Input
                                  placeholder="City"
                                  className="formControl"
                                  value={
                                    flooringcontractorData?.commisioning_party_city
                                  }
                                  onChange={props.handleChange(
                                    'flooring_contractor_city'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_city') }}
                                  defaultValue={
                                    props.values.flooring_contractor_city
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="State"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_state
                                }
                                name="flooring_contractor_state"
                              >
                                <Input
                                  placeholder="State"
                                  className="formControl"
                                  value={
                                    flooringcontractorData?.commisioning_party_state
                                  }
                                  onChange={props.handleChange(
                                    'flooring_contractor_state'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_state') }}
                                  defaultValue={
                                    props.values.flooring_contractor_state
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Country"
                                name="flooring_contractor_country"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_country
                                }
                              >
                                <Input
                                  placeholder="Country"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'flooring_contractor_country'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_country') }}
                                  defaultValue={
                                    props.values.flooring_contractor_country
                                  }
                                  value={
                                    flooringcontractorData?.commisioning_party_country
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Zip"
                                name="flooring_contractor_zip"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_zip
                                }
                              >
                                <Input
                                  placeholder="Zip"
                                  className="formControl"
                                  value={
                                    flooringcontractorData?.commisioning_party_zip
                                  }
                                  onChange={props.handleChange(
                                    'flooring_contractor_zip'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_zip') }}
                                  defaultValue={
                                    props.values.flooring_contractor_zip
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Contact Number"
                                name="flooring_contractor_contact_number"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_contact_number
                                }
                              >
                                <Input
                                  placeholder="Contact Number"
                                  className="formControl"
                                  value={
                                    flooringcontractorData?.commisioning_party_contact_number
                                  }
                                  onChange={props.handleChange(
                                    'flooring_contractor_contact_number'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_contact_number') }}
                                  defaultValue={
                                    props.values
                                      .flooring_contractor_contact_number
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Email"
                                name="flooring_contractor_email"
                                valuePropName={
                                  flooringcontractorData?.commisioning_party_email
                                }
                              >
                                <Input
                                  placeholder="Email"
                                  className="formControl"
                                  value={
                                    flooringcontractorData?.commisioning_party_email
                                  }
                                  onChange={props.handleChange(
                                    'flooring_contractor_email'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('flooring_contractor_email') }}
                                  defaultValue={
                                    props.values.flooring_contractor_email
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                      <Panel header="General Contractor Information" key="4">
                        <Row gutter={16}>
                          <div className="m-2">
                            <Form.Item name="generalContractor">
                              <Checkbox

                                onChange={getGeneralContractorData}
                                defaultChecked={props.values.generalContractor}
                              >
                                Check this box if General Contractor is
                                Commissioning Party
                              </Checkbox>
                            </Form.Item>
                          </div>
                        </Row>
                        <Row gutter={16}>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Name"
                                valuePropName={
                                  generalcontractor?.commisioning_name
                                }
                                name="general_contractor_name"
                              >
                                <Input
                                  placeholder="Name"
                                  className="formControl"
                                  value={generalcontractor?.commisioning_name}
                                  onChange={props.handleChange(
                                    'general_contractor_name'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_name') }}
                                  defaultValue={
                                    props.values.general_contractor_name
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Street Name/Number "
                                name="general_contractor_street"
                                valuePropName={
                                  generalcontractor?.commisioning_party_street
                                }
                              >
                                <Input
                                  placeholder="Street Name/Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'general_contractor_street'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_street') }}
                                  value={generalcontractor?.commisioning_party_street}
                                  defaultValue={
                                    props.values.general_contractor_street
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="City"
                                valuePropName={
                                  generalcontractor?.commisioning_party_city
                                }
                                name="general_contractor_city"
                              >
                                <Input
                                  placeholder="City"
                                  className="formControl"
                                  value={
                                    generalcontractor?.commisioning_party_city
                                  }
                                  onChange={props.handleChange(
                                    'general_contractor_city'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_city') }}
                                  defaultValue={
                                    props.values.general_contractor_city
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="State"
                                valuePropName={
                                  generalcontractor?.commisioning_party_state
                                }
                                name="general_contractor_state"
                              >
                                <Input
                                  placeholder="State"
                                  className="formControl"
                                  value={
                                    generalcontractor?.commisioning_party_state
                                  }
                                  onChange={props.handleChange(
                                    'general_contractor_state'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_state') }}
                                  defaultValue={
                                    props.values.general_contractor_state
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Country"
                                name="general_contractor_country"
                                valuePropName={
                                  generalcontractor?.commisioning_party_country
                                }
                              >
                                <Input
                                  placeholder="Country"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'general_contractor_country'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_country') }}
                                  defaultValue={
                                    props.values.general_contractor_country
                                  }
                                  value={
                                    generalcontractor?.commisioning_party_country
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Zip"
                                valuePropName={
                                  generalcontractor?.commisioning_party_zip
                                }
                                name="general_contractor_zip"
                              >
                                <Input
                                  placeholder="Zip"
                                  className="formControl"
                                  value={
                                    generalcontractor?.commisioning_party_zip
                                  }
                                  onChange={props.handleChange(
                                    'general_contractor_zip'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_zip') }}
                                  defaultValue={
                                    props.values.general_contractor_zip
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Contact Number"
                                name="general_contractor_contact_number"
                                valuePropName={
                                  generalcontractor?.commisioning_party_contact_number
                                }
                              >
                                <Input
                                  placeholder="Contact Number"
                                  className="formControl"
                                  value={
                                    generalcontractor?.commisioning_party_contact_number
                                  }
                                  onChange={props.handleChange(
                                    'general_contractor_contact_number'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_contact_number') }}
                                  defaultValue={
                                    props.values
                                      .general_contractor_contact_number
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Email"
                                name="general_contractor_email"
                                valuePropName={
                                  generalcontractor?.commisioning_party_email
                                }
                              >
                                <Input
                                  placeholder="Email"
                                  className="formControl"
                                  value={
                                    generalcontractor?.commisioning_party_email
                                  }
                                  onChange={props.handleChange(
                                    'general_contractor_email'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('general_contractor_email') }}
                                  defaultValue={
                                    props.values.general_contractor_email
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                      <Panel header="Manufacturer Information" key="5">
                        <Row gutter={16}>
                          <div className="m-2">
                            <Form.Item name="manufacturerData">
                              <Checkbox
                                onChange={getManufacturerData}
                                defaultChecked={props.values.manufacturerData}
                              >
                                Check this box if Manufacturer is Commissioning
                                Party
                              </Checkbox>
                            </Form.Item>
                          </div>
                        </Row>
                        <Row gutter={16}>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Name"
                                name="manufacturer_name"
                                valuePropName={
                                  manufacturerData?.commisioning_name
                                }
                              >
                                <Input
                                  placeholder="Name"
                                  className="formControl"
                                  value={manufacturerData?.commisioning_name}
                                  onChange={props.handleChange(
                                    'manufacturer_name'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_name') }}
                                  defaultValue={props.values.manufacturer_name}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Street Name/Number "
                                name="manufacturer_street"
                                valuePropName={
                                  manufacturerData?.commisioning_party_street
                                }
                              >
                                <Input
                                  placeholder="Street Name/Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'manufacturer_street'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_street') }}
                                  value={
                                    manufacturerData?.commisioning_party_street
                                  }
                                  defaultValue={
                                    props.values.manufacturer_street
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="City"
                                name="manufacturer_city"
                                valuePropName={
                                  manufacturerData?.commisioning_party_city
                                }
                              >
                                <Input
                                  placeholder="City"
                                  className="formControl"
                                  value={
                                    manufacturerData?.commisioning_party_city
                                  }
                                  onChange={props.handleChange(
                                    'manufacturer_city'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_city') }}
                                  defaultValue={props.values.manufacturer_city}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="State"
                                name="manufacturer_state"
                                valuePropName={
                                  manufacturerData?.commisioning_party_state
                                }
                              >
                                <Input
                                  placeholder="State"
                                  className="formControl"
                                  value={
                                    manufacturerData?.commisioning_party_state
                                  }
                                  onChange={props.handleChange(
                                    'manufacturer_state'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_state') }}
                                  defaultValue={props.values.manufacturer_state}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Country"
                                name="manufacturer_country"
                                valuePropName={
                                  manufacturerData?.commisioning_party_city
                                }
                              >
                                <Input
                                  placeholder="Country"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'manufacturer_country'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_country') }}
                                  defaultValue={
                                    props.values.manufacturer_country
                                  }
                                  value={
                                    manufacturerData?.commisioning_party_state
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Zip"
                                name="manufacturer_zip"
                                valuePropName={
                                  manufacturerData?.commisioning_party_zip
                                }
                              >
                                <Input
                                  placeholder="Zip"
                                  className="formControl"
                                  value={
                                    manufacturerData?.commisioning_party_zip
                                  }
                                  onChange={props.handleChange(
                                    'manufacturer_zip'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_zip') }}
                                  defaultValue={props.values.manufacturer_zip}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Main Contact Info"
                                //  valuePropName={manufacturerData?.commisioning_party_contact_number}
                                name="manufacturer_contact_info"
                              >
                                <Input
                                  placeholder="Main Contact Info"
                                  className="formControl"
                                  // value={manufacturerData?.commisioning_party_contact_number}
                                  onChange={props.handleChange(
                                    'manufacturer_contact_info'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_contact_info') }}
                                  defaultValue={
                                    props.values.manufacturer_contact_info
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Title"
                                // valuePropName={manufacturerData?.h_eu_zip}
                                name="manufacturer_title"
                              >
                                <Input
                                  placeholder="Title"
                                  // value={manufacturerData?.h_eu_zip}
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'manufacturer_title'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_title') }}
                                  defaultValue={props.values.manufacturer_title}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Contact Number"
                                valuePropName={
                                  manufacturerData?.commisioning_party_contact_number
                                }
                                name="manufacturer_contact_number"
                              >
                                <Input
                                  placeholder="Contact Number"
                                  value={
                                    manufacturerData?.commisioning_party_contact_number
                                  }
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'manufacturer_contact_number'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_contact_number') }}
                                  defaultValue={
                                    props.values.manufacturer_contact_number
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Email"
                                valuePropName={
                                  manufacturerData?.commisioning_party_email
                                }
                                name="manufacturer_email"
                              >
                                <Input
                                  placeholder="Email"
                                  value={
                                    manufacturerData?.commisioning_party_email
                                  }
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'manufacturer_email'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('manufacturer_email') }}
                                  defaultValue={props.values.manufacturer_email}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                      <Panel header="Retailer Information" key="6">
                        <Row gutter={16}>
                          <div className="m-2">
                            <Form.Item name="reatailerData">
                              <Checkbox
                                onChange={getReatailerData}
                                defaultChecked={props.values.reatailerData}
                              >
                                Check this box if Retailer is Commissioning
                                Party
                              </Checkbox>
                            </Form.Item>
                          </div>
                        </Row>
                        <Row gutter={16}>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Name"
                                valuePropName={reatailerData?.commisioning_name}
                                name="retailer_name"
                              >
                                <Input
                                  placeholder="Name"
                                  value={reatailerData?.commisioning_name}
                                  className="formControl"
                                  onChange={props.handleChange('retailer_name')}
                                  style={{ backgroundColor: getFieldBgColor('retailer_name') }}
                                  defaultValue={props.values.retailer_name}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Street Name/Number "
                                name="retailer_street"
                                valuePropName={
                                  reatailerData?.commisioning_party_street
                                }
                              >
                                <Input
                                  placeholder="Street Name/Number"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'retailer_street'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_street') }}
                                  value={
                                    reatailerData?.commisioning_party_street
                                  }
                                  defaultValue={props.values.retailer_street}
                                />
                              </Form.Item>
                            </div>
                          </Col>

                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="City"
                                valuePropName={
                                  reatailerData?.commisioning_party_city
                                }
                                name="retailer_city"
                              >
                                <Input
                                  placeholder="City"
                                  value={reatailerData?.commisioning_party_city}
                                  className="formControl"
                                  onChange={props.handleChange('retailer_city')}
                                  style={{ backgroundColor: getFieldBgColor('retailer_city') }}
                                  defaultValue={props.values.retailer_city}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="State"
                                name="retailer_state"
                                valuePropName={
                                  reatailerData?.commisioning_party_state
                                }
                              >
                                <Input
                                  placeholder="State"
                                  className="formControl"
                                  value={
                                    reatailerData?.commisioning_party_state
                                  }
                                  onChange={props.handleChange(
                                    'retailer_state'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_state') }}
                                  defaultValue={props.values.retailer_state}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Country"
                                name="retailer_country"
                                valuePropName={
                                  reatailerData?.commisioning_party_country
                                }
                              >
                                <Input
                                  placeholder="Country"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'retailer_country'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_country') }}
                                  defaultValue={props.values.retailer_country}
                                  value={
                                    reatailerData?.commisioning_party_country
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Zip"
                                name="retailer_zip"
                                valuePropName={
                                  reatailerData?.commisioning_party_zip
                                }
                              >
                                <Input
                                  placeholder="Zip"
                                  className="formControl"
                                  value={reatailerData?.commisioning_party_zip}
                                  onChange={props.handleChange('retailer_zip')}
                                  style={{ backgroundColor: getFieldBgColor('retailer_zip') }}
                                  defaultValue={props.values.retailer_zip}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Main Contact Info"
                                // valuePropName={reatailerData?.h_eu_zip}
                                name="retailer_contact_info"
                              >
                                <Input
                                  placeholder="Main Contact Info"
                                  className="formControl"
                                  // value={reatailerData?.h_eu_zip}
                                  onChange={props.handleChange(
                                    'retailer_contact_info'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_contact_info') }}
                                  defaultValue={
                                    props.values.retailer_contact_info
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Title"
                                valuePropName={reatailerData?.h_eu_zip}
                                name="retailer_title"
                              >
                                <Input
                                  placeholder="Title"
                                  className="formControl"
                                  value={reatailerData?.h_eu_zip}
                                  onChange={props.handleChange(
                                    'retailer_title'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_title') }}
                                  defaultValue={props.values.retailer_title}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Contact Number"
                                name="retailer_contact_number"
                                valuePropName={
                                  reatailerData?.commisioning_party_contact_number
                                }
                              >
                                <Input
                                  placeholder="Contact Number"
                                  className="formControl"
                                  value={
                                    reatailerData?.commisioning_party_contact_number
                                  }
                                  onChange={props.handleChange(
                                    'retailer_contact_number'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_contact_number') }}
                                  defaultValue={
                                    props.values.retailer_contact_number
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Email"
                                valuePropName={
                                  reatailerData?.commisioning_party_email
                                }
                                name="retailer_email"
                              >
                                <Input
                                  placeholder="Email"
                                  value={
                                    reatailerData?.commisioning_party_email
                                  }
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'retailer_email'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('retailer_email') }}
                                  defaultValue={props.values.retailer_email}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                      <Panel header="Jobsite Information" key="7">
                        <Row gutter={16}>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Jobsite Visit Date"
                                name="jobsite_date"
                              >
                                <Input.Group compact className="mt-0">
                                  <Input
                                    placeholder="Jobsite Visit Date"
                                    className="formControl"
                                    onChange={(e) =>
                                      props.handleDateformate(
                                        e,
                                        'jobsite_date',
                                        'text'
                                      )
                                    }
                                    style={{ backgroundColor: getFieldBgColor('jobsite_date') }}
                                    value={props.values.jobsite_date}
                                    onFocus={() =>
                                      props.setCalOpen1(!props.calOpen1)
                                    }
                                    onKeyUp={() => props.setCalOpen1(false)}
                                    onBlur={() => props.setCalOpen1(false)}
                                  />

                                  <Button
                                    className="btnAddOn"
                                    icon={<CalendarOutlined />}
                                    onClick={() =>
                                      props.setCalOpen1(!props.calOpen1)
                                    }
                                  />
                                </Input.Group>
                                <DatePicker
                                  className="formControl dateHide"
                                  format={DateFormat}
                                  open={props.calOpen1}
                                  style={{ visibility: 'hidden', width: 0 ,backgroundColor: getFieldBgColor('jobsite_date')}}
                                  onChange={(e) =>
                                    props.handleDateformate(
                                      e,
                                      'jobsite_date',
                                      'date'
                                    )
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup custom-form-group">
                              <Form.Item label="Time" name="jobsite_time">
                                <Input
                                  className="formGroup customPadding"
                                  addonAfter={
                                    <Cascader
                                      placeholder="AM"
                                      onChange={props.handleChange('time_type')}
                                      style={{ backgroundColor: getFieldBgColor('time_type') }}
                                      options={timeampm}
                                      defaultValue={props.values.time_type}
                                      className="custom-cascadar"
                                    />
                                  }
                                  placeholder="Time"
                                  onChange={props.handleChange('jobsite_time')}
                                  style={{ backgroundColor: getFieldBgColor('jobsite_time') }}
                                  defaultValue={props.values.jobsite_time}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Property Type"
                                name="property_dropdown"
                              >
                                <Select
                                  defaultValue={
                                    props.values.property_dropdown
                                      ? props.values.property_dropdown
                                      : 'Select Property Type'
                                  }
                                  onChange={props.handleChange(
                                    'property_dropdown'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('property_dropdown') }}
                                >
                                  <Option value="Residential">
                                    Residential
                                  </Option>
                                  <Option value="Commercial">Commercial</Option>
                                  <Option value="Rental Unit">
                                    Rental Unit
                                  </Option>
                                  <Option value="Not Applicable">
                                    Not Applicable
                                  </Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Building Type"
                                name="building_type"
                              >
                                <Select
                                  defaultValue={
                                    props.values.building_type
                                      ? props.values.building_type
                                      : 'Select Building Type'
                                  }
                                  onChange={props.handleChange('building_type')}
                                  style={{ backgroundColor: getFieldBgColor('building_type') }}
                                >
                                  <Option value="Single Story">
                                    Single Story
                                  </Option>
                                  <Option value="Multi-Level">
                                    Multi-Level
                                  </Option>
                                  <Option value="Other">Other</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          {props.isOpen.buildingOther === true ||
                          props.values.building_type === 'Other' ? (
                            <Col xs={24} md={6} xl={6}>
                              <div className="formGroup">
                                <Form.Item
                                  label="Other"
                                  name="build_type_other"
                                >
                                  <Input
                                    placeholder="Other"
                                    className="formControl"
                                    onChange={props.handleChange(
                                      'build_type_other'
                                    )}
                                    style={{ backgroundColor: getFieldBgColor('build_type_other') }}
                                    defaultValue={props.values.build_type_other}
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                          ) : null}
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Building Style"
                                name="building_style"
                              >
                                <Select
                                  defaultValue={
                                    props.values.building_style
                                      ? props.values.building_style
                                      : 'Select Building Style'
                                  }
                                  onChange={props.handleChange(
                                    'building_style'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('building_style') }}
                                >
                                  <Option value="Single Family">
                                    Single Family
                                  </Option>
                                  <Option value="Apartment Complex">
                                    Apartment Complex
                                  </Option>
                                  <Option value="Duplex">Duplex</Option>
                                  <Option value="Remodel">Remodel</Option>
                                  <Option value="Condominium">
                                    Condominium
                                  </Option>
                                  <Option value="Church">Church</Option>
                                  <Option value="Common Areas">
                                    Common Areas
                                  </Option>
                                  <Option value="Dental">Dental</Option>
                                  <Option value="Exterior">Exterior</Option>
                                  <Option value="Educational Facility">
                                    Educational Facility
                                  </Option>
                                  <Option value="Golf Course">
                                    Golf Course
                                  </Option>
                                  <Option value="Group Home">Group Home</Option>
                                  <Option value="Hospital">Hospital</Option>
                                  <Option value="Hospitality">
                                    Hospitality
                                  </Option>
                                  <Option value="Manufactured Home">
                                    Manufactured Home
                                  </Option>
                                  <Option value="Medical">Medical </Option>
                                  <Option value="Offices">Offices</Option>
                                  <Option value="Office Building">
                                    Office Building
                                  </Option>
                                  <Option value="Retail Store">
                                    Retail Store
                                  </Option>
                                  <Option value="Veterinary">Veterinary</Option>
                                  <Option value="Watercraft">Watercraft</Option>
                                  <Option value="Other">Other</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          {props.isOpen.buildingStyleOther === true ||
                          props.values.building_style === 'Other' ? (
                            <Col xs={24} md={6} xl={6}>
                              <div className="formGroup">
                                <Form.Item
                                  label="Other"
                                  name="other_building_style"
                                >
                                  <Input
                                    placeholder="Other"
                                    className="formControl"
                                    onChange={props.handleChange(
                                      'other_building_style'
                                    )}
                                    style={{ backgroundColor: getFieldBgColor('other_building_style') }}
                                    defaultValue={
                                      props.values.other_building_style
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                          ) : null}
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                label="Age of Building"
                                name="jobsite__age_building"
                              >
                                <Input
                                  placeholder="Age of Building"
                                  className="formControl"
                                  onChange={props.handleChange(
                                    'jobsite__age_building'
                                  )}
                                  style={{ backgroundColor: getFieldBgColor('jobsite__age_building') }}
                                  defaultValue={
                                    props.values.jobsite__age_building
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              
                              <Form.Item
                              label="New Construction?"
                              name="h_bui_cons"
                                  >
                                    {console.warn("tripleToggle")}
                                    <TripleToggle
                                    value={props.values.h_bui_cons}
                                    onToggle={props.handleChange('h_bui_cons')}
                                  />
                            </Form.Item>
                            </div>
                            {props.isOpen.constructionField === true ||
                            props.values.h_bui_cons === 'Yes' ? (
                              <div>
                                <Row gutter={16}>
                                  <Col xs={24} md={24} xl={24}>
                                    <div className="formGroup">
                                      <Form.Item
                                        label="Closing Date"
                                        name="closing_date"
                                      >
                                        <Input.Group compact className="mt-0">
                                          <Input
                                            placeholder="Closing Date"
                                            className="formControl"
                                            onChange={(e) =>
                                              props.handleDateformate(
                                                e,
                                                'closing_date',
                                                'text'
                                              )
                                            }
                                            style={{ backgroundColor: getFieldBgColor('closing_date') }}
                                            value={props.values.closing_date}
                                            onFocus={() =>
                                              props.setCalOpen3(!props.calOpen3)
                                            }
                                            onKeyUp={() =>
                                              props.setCalOpen3(false)
                                            }
                                            onBlur={() =>
                                              props.setCalOpen3(false)
                                            }
                                          />

                                          <Button
                                            className="btnAddOn"
                                            icon={<CalendarOutlined />}
                                            onClick={() =>
                                              props.setCalOpen3(!props.calOpen3)
                                            }
                                          />
                                        </Input.Group>
                                        <DatePicker
                                          className="formControl dateHide"
                                          format={DateFormat}
                                          open={props.calOpen3}
                                          style={{
                                            visibility: 'hidden',
                                            width: 0,
                                            backgroundColor: getFieldBgColor('closing_date')
                                          }}
                                          onChange={(e) =>
                                            props.handleDateformate(
                                              e,
                                              'closing_date',
                                              'date'
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="formGroup">
                                      <Form.Item
                                        label="Move in Date"
                                        name="moving_date"
                                      >
                                        <Input.Group compact className="mt-0">
                                          <Input
                                            placeholder="Move in Date"
                                            className="formControl"
                                            onChange={(e) =>
                                              props.handleDateformate(
                                                e,
                                                'moving_date',
                                                'text'
                                              )
                                            }
                                            style={{ backgroundColor: getFieldBgColor('moving_date') }}
                                            value={props.values.moving_date}
                                            onFocus={() =>
                                              props.setCalOpen4(!props.calOpen4)
                                            }
                                            onKeyUp={() =>
                                              props.setCalOpen4(false)
                                            }
                                            onBlur={() =>
                                              props.setCalOpen4(false)
                                            }
                                          />

                                          <Button
                                            className="btnAddOn"
                                            icon={<CalendarOutlined />}
                                            onClick={() =>
                                              props.setCalOpen4(!props.calOpen4)
                                            }
                                          />
                                        </Input.Group>
                                        <DatePicker
                                          className="formControl dateHide"
                                          format={DateFormat}
                                          open={props.calOpen4}
                                          style={{
                                            visibility: 'hidden',
                                            width: 0,
                                            backgroundColor: getFieldBgColor('moving_date')
                                          }}
                                          onChange={(e) =>
                                            props.handleDateformate(
                                              e,
                                              'moving_date',
                                              'date'
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="formGroup">
                                      <Form.Item
                                        label="HVAC Operational Date"
                                        name="operational_date"
                                      >
                                        <Input.Group compact className="mt-0">
                                          <Input
                                            placeholder="HVAC Operational Date"
                                            className="formControl"
                                            onChange={(e) =>
                                              props.handleDateformate(
                                                e,
                                                'operational_date',
                                                'text'
                                              )
                                            }
                                            style={{ backgroundColor: getFieldBgColor('claim_num') }}
                                            value={
                                              props.values.operational_date
                                            }
                                            onFocus={() =>
                                              props.setCalOpen5(!props.calOpen5)
                                            }
                                            onKeyUp={() =>
                                              props.setCalOpen5(false)
                                            }
                                            onBlur={() =>
                                              props.setCalOpen5(false)
                                            }
                                          />

                                          <Button
                                            className="btnAddOn"
                                            icon={<CalendarOutlined />}
                                            onClick={() =>
                                              props.setCalOpen5(!props.calOpen5)
                                            }
                                          />
                                        </Input.Group>
                                        <DatePicker
                                          className="formControl dateHide"
                                          format={DateFormat}
                                          open={props.calOpen5}
                                          style={{
                                            visibility: 'hidden',
                                            width: 0,
                                            backgroundColor: getFieldBgColor('operational_date')
                                          }}
                                          onChange={(e) =>
                                            props.handleDateformate(
                                              e,
                                              'operational_date',
                                              'date'
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ) : (
                              ''
                            )}
                          </Col>
                          <Col xs={24} md={6} xl={6}>
                            <div className="formGroup">
                              <Form.Item
                                  label="Occupied"
                                  name="h_bui_occupied"
                                >
                                  {console.warn('TripleToggle')}
                                  <TripleToggle
                                  value={props.values.h_bui_occupied}
                                  onToggle={props.handleChange('h_bui_occupied')}
                                />
                            </Form.Item>
                            </div>
                            {props.isOpen.buildField === true ||
                            props.values.h_bui_occupied === 'Yes' ? (
                              <div>
                                <Row>
                                  <Col xs={24} md={24} xl={24}>
                                    <div className="formGroup">
                                      <Form.Item label="Adults" name="adults">
                                        <Input
                                          placeholder="Adults"
                                          className="formControl"
                                          onChange={props.handleChange(
                                            'adults'
                                          )}
                                          style={{ backgroundColor: getFieldBgColor('adults') }}
                                          defaultValue={props.values.adults}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="formGroup">
                                      <Form.Item
                                        label="Children"
                                        name="childrens"
                                      >
                                        <Input
                                          placeholder="Children"
                                          className="formControl"
                                          onChange={props.handleChange(
                                            'childrens'
                                          )}
                                          style={{ backgroundColor: getFieldBgColor('childrens') }}
                                          defaultValue={props.values.childrens}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="formGroup">
                                      <Form.Item label="Pets" name="pets">
                                        <Input
                                          placeholder="Pets"
                                          className="formControl"
                                          onChange={props.handleChange('pets')}
                                          style={{ backgroundColor: getFieldBgColor('pets') }}
                                          defaultValue={props.values.pets}
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ) : (
                              ''
                            )}
                          </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col xs={24} md={24} xl={24}>
                            <div className="formGroup">
                              <Form.Item
                                label="Statement of Concern"
                                name="concerns"
                              >
                                <TextArea
                                  placeholder="Statement of Concern"
                                  className="customTextarea"
                                  onChange={props.handleChange('concerns')}
                                  style={{ backgroundColor: getFieldBgColor('concerns') }}
                                  defaultValue={props.values.concerns}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Form>
      )}
    </>
  );
};

export default FirstStep;
